export const buildFilter = (filters) => {
  // debugger; // eslint-disable-line

  if (!filters) return {};
  return filters.reduce((acc, filter) => {
    return {
      ...acc,
      [filter.criteria]: [
        ...(acc[filter.criteria] || []),
        {
          type: filter.operator,
          value: filter.value,
        },
      ],
    };
  }, {});
};
